// 9fbef606107a605d69c0edbcd8029e5d
import { takeLatest, call, put, takeLeading, select } from 'redux-saga/effects';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import PROMOTIONS_ABSTRACTOR from '@tcp/core/src/services/abstractors/common/Promotions/Promotions.js';
import {
  getcouponOnHoldEmptyCartEnabled,
  getIsUpdatedPromotionsDisplayEnabled,
  getIsOptimizedApplyCouponEnabled,
  getIsNewPromotionsAPIEnabled,
  getIsBuyMorePromoEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import BagPageSelectors from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { getCartItemCount } from '@tcp/core/src/utils/cookie.util';
import {
  handleError,
  filteredPromotions,
} from '@tcp/core/src/components/common/organisms/Promotions/utils/util';
import {
  setAllPromotions,
  setPromotionsDetails,
  setAllOfferTypeBasedPromotionsData,
} from './Promotions.action';
import { PROMOTIONS_CONSTANT } from './Promotions.constants';

const fileName = 'Promotions.saga.js';

export function* fetchAllPromotionsData() {
  try {
    const isNewPromotionsAPIEnabled = yield select(getIsNewPromotionsAPIEnabled);
    const isUpdatedPromotionsDisplayEnabled = yield select(getIsUpdatedPromotionsDisplayEnabled);
    const isOptimizedApplyCouponEnabled = yield select(getIsOptimizedApplyCouponEnabled);
    const isBuyMorePromoEnabled = yield select(getIsBuyMorePromoEnabled);
    if (
      isNewPromotionsAPIEnabled ||
      isUpdatedPromotionsDisplayEnabled ||
      isOptimizedApplyCouponEnabled ||
      isBuyMorePromoEnabled
    ) {
      const promotionResponse = yield call(PROMOTIONS_ABSTRACTOR.getAllPromotionsData);
      const offerTypeBasedPromotion = filteredPromotions(promotionResponse);
      yield put(setAllPromotions(promotionResponse));
      yield put(setAllOfferTypeBasedPromotionsData(offerTypeBasedPromotion));
    }
  } catch (e) {
    console.log(e, 'error in Promotions GraphQl api');
  }
}

export function* fetchPromotionsDetails(action) {
  const { payload } = action;
  try {
    const response = yield call(PROMOTIONS_ABSTRACTOR.getPromotionDetailsData, payload);
    yield put(setPromotionsDetails(response));
  } catch (e) {
    console.log(e, 'error in Promotions details GraphQl api');
  }
}

/**
 * Handles coupon-related logic.
 * Executes the provided callback function with required parameters.
 * Catches and logs any errors that occur during execution.
 *
 * @param {Function} callback - The callback function to be executed with required parameters.
 * @returns {Generator} A generator function that executes the callback function.
 */
export function* couponHandler(callback) {
  const methodName = 'couponHandler';
  try {
    const bagPageErrorMappings = yield select(BagPageSelectors.getErrorMapping);
    const cartItemCount = yield call(getCartItemCount, true);
    const isCouponOnHoldEmptyCartEnabled = yield select(getcouponOnHoldEmptyCartEnabled);
    return yield callback(bagPageErrorMappings, cartItemCount, isCouponOnHoldEmptyCartEnabled);
  } catch (error) {
    handleError({ error, payload: {}, methodName, fileName });
    return null;
  }
}

function* PromotionsSaga() {
  const cachedfetchAllPromotionsData = validateReduxCache(fetchAllPromotionsData);
  yield takeLeading(PROMOTIONS_CONSTANT.FETCH_ALL_PROMOTIONS, cachedfetchAllPromotionsData);
  yield takeLatest(PROMOTIONS_CONSTANT.FETCH_PROMOTION_DETAILS, fetchPromotionsDetails);
}

export default PromotionsSaga;
